import { differenceInHours, format } from "date-fns";
import Moment from "moment";
let localWindow = (window as any)
export let placeAddresCompoponent = {
  ZIP_CODE: "postal_code",
  COUNTRY: "country",
  STATE: "administrative_area_level_1",
  CITY: "administrative_area_level_2",
  TOWN: "sublocality_level_1",
  AREA: "sublocality_level_2",
  NEAREST_ROAD: "route",
};
export function getAddressComponent(address_components: any, key: any) {
  var value = "";
  var postalCodeType = address_components.filter((aComp: any) =>
    aComp.types.some((typesItem: any) => typesItem === key)
  );
  if (postalCodeType != null && postalCodeType.length > 0)
    value = postalCodeType[0].long_name;
  return value;
}

export function addDays(date?: any, day?: any) {
  return Moment(date).add(day, 'days').toDate();
}

export function formatDateTime(date: any, format: any) {
  Moment.locale("en");
  return Moment(date).format(format);
}

export function calculateDistance(
  lattitude1: any,
  longittude1: any,
  lattitude2: any,
  longittude2: any
) {
  const toRadian = (n: any) => (n * Math.PI) / 180;

  let lat2 = lattitude2;
  let lon2 = longittude2;
  let lat1 = lattitude1;
  let lon1 = longittude1;

  let R = 6371;
  let x1 = lat2 - lat1;
  let dLat = toRadian(x1);
  let x2 = lon2 - lon1;
  let dLon = toRadian(x2);
  let a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadian(lat1)) *
    Math.cos(toRadian(lat2)) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);
  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let d = R * c;
  return d.toFixed(2);
}


export function dateRange(dateList: any, start: Date, end: Date) {
  if (dateList.length !== 0 && start !== undefined && end !== undefined) {
    const data = dateList.filter((element: Date) => {
      if (Moment(element).isSame(start, 'day') || Moment(element).isSame(end, 'day')) {
        return element;
      } else {
        return Moment(element).isBetween(start, end);

      }
    });
    return data.length > 0 ? true : false;
  }
}

export const getParkingPassStatus = (checkinDate: any, checkoutDate: any, actualCheckinTime: any, actualCheckoutTime: any) => {
  var today = new Date();
  if (actualCheckinTime === null && actualCheckoutTime === null && !(Moment(checkinDate) < Moment(today) && Moment(checkoutDate) < Moment(today))) {
    return 'Booked';
  } else if (actualCheckoutTime === null) {
    return 'Active';
  } else if (Moment(checkinDate) < Moment(today) && Moment(checkoutDate) < Moment(today)) {
    return 'Expired';
  }
};

export function getInitials(value: any) {
  if (value) {
    return value
      .match(/\b(\w)/g)
      .join("")
      .toUpperCase();
  }
}

export function formatTimeHHMM(date: any, format: any) {
  Moment.locale('en');
  return Moment(date).format(format);
}

export const getBookingStatusColor: any = {
  Completed: "rgba(52, 168, 83, 0.15)",
  booked: "#f8bdc2",
  cancel: "rgba(234, 67, 53, 0.15)",
  "Cancellation in review": "rgba(234, 67, 53, 0.15)",
};

export const getBookingStatusTextColor: any = {
  Completed: "#34A853",
  booked: "#e23744",
  cancel: "#EA4335",
  "Cancellation in review": "#EA4335",
};

export function getAmount(type: string, amount: number, cent: number) {
  if (type === "$") return cent.toFixed(2);
  return ((cent * amount) / 100).toFixed(2);
}

export function roundNumber(value: number) {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}
export const getSlabRate: any = {
  Bronze: "Earn 1% reward",
  Silver: "Earn 1.5% reward",
  Gold: "Earn 2% reward",
};



export function timeCheck(bookDate: Date) {
  var now = Moment(new Date());
  var end = Moment(bookDate);
  var duration = Moment.duration(now.diff(end));
  return duration.asMinutes() < -30 ? true : false;
}
export function isCheckoutTimeExpired(bookDate: Date) {
  let now = Moment(new Date()); //todays date
  let end = Moment(bookDate); // another date
  let duration = Moment.duration(now.diff(end));
  return duration.asMinutes() > 0 ? true : false;
}

export function isBookingExpired(start: Date, end: Date) {
  let startDuration = Moment.duration(
    Moment(new Date()).diff(Moment.utc(start).local().format())
  ).asMinutes();
  let endDuration = Moment.duration(
    Moment(new Date()).diff(Moment.utc(end).local().format())
  ).asMinutes();

  if (startDuration > -60 || endDuration > -60) {
    return true;
  } else {
    return Moment().isBetween(start, end);
  }
}
export function formatPhoneNumber(phoneNumberString: any) {
  let cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    let intlCode = match[1] ? "+1 " : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return null;
}

export const normalizeInput = (value: any) => {
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, "");
  const cvLength = currentValue.length;

  if (value.length > 9) {
    if (cvLength < 4) return currentValue;
    if (cvLength < 7)
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
      3,
      6
    )}-${currentValue.slice(6, 10)}`;
  }
};

export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'INR',

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});




export function last4Character(value: string) {
  let val = value;
  let fourChar = val.substring(val.length - 4);
  return fourChar;
}

export function timeRange(minRange: any, start: Date, end: Date) {
  var timeDiff = differenceInHours(end, start);

  if (timeDiff >= minRange) {
    return false;
  } else {
    return true;
  }
}

export function checkMinimumBookingHrs(
  minBookingHours: any,
  start: Date,
  end: Date
) {
  var timeDiff = differenceInHours(end, start);
  if (timeDiff >= minBookingHours) {
    return true;
  } else {
    return false;
  }
}
export function getUniqueKey() {
  return Date.now().toString(36) + Math.random().toString(36).substring(2)
}

export function tagManager(eventName: String, eventObj?: any) {
  if (typeof window != "undefined") { // needed if SSR
    localWindow?.fbq && localWindow?.fbq('track', eventName, eventObj);
    localWindow.gtag && localWindow.gtag('event', eventName, eventObj);
  }
}


export const formatDate = (date: Date) => {
  return format(date, "EEE, dd MMM 'yy, hh:mm a");
};

export const formatIndianDateTime = (date: string) => {
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'short',  // "Thu"
    year: 'numeric',   // "2024"
    month: 'short',    // "Dec"
    day: 'numeric',    // "12"
    hour: '2-digit',   // "17"
    minute: '2-digit', // "30"
    hour12: true,      // "PM/AM"
  };

  const indianDate = new Date(date).toLocaleString('en-IN', options);
  return indianDate;
};

export const getDate = (isoString: any) => {
  const date = new Date(isoString);
  const formattedDate = date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric", // Add the year
  });
  return formattedDate;
};


export const getTime = (isoString: any) => {
  const date = new Date(isoString);
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return formattedTime
};

export function onlyLastFourNum(value: any) {
  if (value !== undefined && value !== null) {
    let replaced = value.replace(/.(?=.{4,}$)/g, '*');
    return replaced;
  } else {
    return '';
  }
}
export function onlyLastEmailShow(value: any) {
  if (value !== undefined && value !== null) {
    let replaced = value.replace(/.(?=.{13,}$)/g, '*');
    return replaced;
  } else {
    return '';
  }
}

export function capitalName(value: any): string {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1);
}


export function addHoursToDate(checkinTime: any, hoursToAdd: any) {
  const date = new Date(checkinTime);
  // Add the integer hours
  date.setHours(date.getHours() + Math.floor(hoursToAdd));

  // Add fractional minutes
  date.setMinutes(date.getMinutes() + (hoursToAdd % 1) * 60);

  // Format the date to match "YYYY-MM-DDTHH:mm:ss.SSS+0530"
  const pad = (num: any) => String(num).padStart(2, "0");

  // Get offset in ±HHmm format
  const offsetMinutes = date.getTimezoneOffset(); // in minutes
  const offsetHours = Math.abs(Math.floor(offsetMinutes / 60));
  const offsetMins = Math.abs(offsetMinutes % 60);
  const offsetSign = offsetMinutes > 0 ? "-" : "+"; // Reverse sign since getTimezoneOffset() returns negative for +0530

  return (
    `${date.getFullYear()}-` +
    `${pad(date.getMonth() + 1)}-` +
    `${pad(date.getDate())}T` +
    `${pad(date.getHours())}:` +
    `${pad(date.getMinutes())}:` +
    `${pad(date.getSeconds())}.` +
    `${pad(date.getMilliseconds())}${offsetSign}` +
    `${pad(offsetHours)}${pad(offsetMins)}`
  );
}



